import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';

const MessageCard = () => {
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const [marketingMessage, setMarketingMessage] = useState();

  const getMessage = async () => {
    try {
      const {
        data: [m]
      } = await dispatchAPI('GET', {
        url: 'settings?label=TOP_BANNER'
      });
      setMarketingMessage(m?.value);
    } catch (e) {
      message(e);
    }
  };

  useEffect(() => {
    (async () => {
      await getMessage();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <Card className="message-card-home">
      <p>{marketingMessage}</p>
    </Card>
  );
};

export { MessageCard };
